/**
 * 문서 파일의 아이콘·색상·크기 표기.
 *
 * 원래 SiteDocumentsPage 안에 있던 로직인데 업로드 다이얼로그에서도 같은 표기를
 * 써야 해서(고른 파일과 목록의 파일이 다르게 보이면 안 된다) 여기로 옮겼다.
 */
import {
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
  TableChart as TableIcon,
  Article as ArticleIcon,
  FolderZip as ZipIcon,
  Architecture as CadIcon,
  InsertDriveFile as FileIcon,
} from '@mui/icons-material';

/** 확장자/MIME 으로 파일 유형 아이콘 + 색상 — 한눈에 종류를 구분. */
export const documentFileVisual = (
  name: string,
  mime?: string,
): { Icon: typeof FileIcon; color: string } => {
  const ext = (name.split('.').pop() || '').toLowerCase();
  const m = (mime || '').toLowerCase();
  if (
    m.startsWith('image/') ||
    ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'heic'].includes(ext)
  ) {
    return { Icon: ImageIcon, color: '#00897b' };
  }
  if (m === 'application/pdf' || ext === 'pdf') return { Icon: PdfIcon, color: '#e53935' };
  if (['xls', 'xlsx', 'csv'].includes(ext)) return { Icon: TableIcon, color: '#43a047' };
  if (['doc', 'docx', 'hwp', 'hwpx', 'txt', 'rtf', 'ppt', 'pptx'].includes(ext)) {
    return { Icon: ArticleIcon, color: '#1e88e5' };
  }
  if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return { Icon: ZipIcon, color: '#fb8c00' };
  if (['dwg', 'dxf'].includes(ext)) return { Icon: CadIcon, color: '#8e24aa' };
  return { Icon: FileIcon, color: '#757575' };
};

export const formatDocumentSize = (bytes?: number): string => {
  if (!bytes || bytes <= 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
